import PropTypes from 'prop-types';
import React from 'react';

import Theme from 'styles/theme';
import I18n from 'utils/I18n';

const CartGiftMessage = ({ viewGiftMessage, giftMessage, useLogoFreePackaging }) => {
  const determineSetMessage = () => {
    if (giftMessage && useLogoFreePackaging) {
      return I18n.localize('cart.gifting.messageLogoFreeSet');
    }
    if (useLogoFreePackaging) {
      return I18n.localize('cart.gifting.logoFreePackagingSet');
    }
    return I18n.localize('cart.gifting.messageSet');
  };

  return (
    <div className="CartGiftMessage">
      <div className="CartGiftMessage__flex">
        <div className="CartGiftMessage__message">{determineSetMessage()}</div>
        <button onClick={viewGiftMessage} className="CartGiftMessage__link">
          {I18n.localize('cart.edit')}
        </button>
      </div>

      <style jsx>{`
        .CartGiftMessage {
          width: 100%;
        }

        .CartGiftMessage__message {
          width: 100%;
          font-size: ${Theme.get('font-size-small-px')};
          padding: ${Theme.get('spacing') * 2}px 0;
          letter-spacing: ${Theme.get('letter-spacing-px')};
          line-height: ${Theme.get('spacing') * 4.5}px;
        }

        .CartGiftMessage__flex {
          display: flex;
          justify-content: space-between;
        }

        .CartGiftMessage__link {
          background: none;
          border: none;
          padding: 0;
          font: inherit;
          cursor: pointer;
          outline: inherit;
          text-decoration: underline;
          color: ${Theme.get('colors-black')};
        }

        .CartGiftMessage__link.focused {
          outline: 2px solid ${Theme.get('colors-black')};
        }
      `}</style>
    </div>
  );
};

CartGiftMessage.propTypes = {
  viewGiftMessage: PropTypes.func.isRequired,
  giftMessage: PropTypes.string,
  useLogoFreePackaging: PropTypes.bool,
};

CartGiftMessage.defaultProps = {
  giftMessage: null,
  useLogoFreePackaging: false,
};

export default CartGiftMessage;
